export const ItemLabelVariables = [
  {
    key: 'NOMBRE_PRODUCTO',
    title: 'Nombre del producto',
  },
  {
    key: 'OPCIONES',
    title: 'Opciones del producto',
  },
  {
    key: 'RECETA',
    title: 'Receta del producto',
  },
  {
    key: 'NUMERO_PEDIDO',
    title: 'Número de pedido',
    onlyOrder: true,
  },
  {
    key: 'NOMBRE_CLIENTE',
    title: 'Nombre del cliente',
    onlyOrder: true,
  },
  {
    key: 'TIPO_PEDIDO',
    title: 'Tipo de pedido',
    onlyOrder: true,
  },
  {
    key: 'HORARIO',
    title: 'Horario',
  },
  {
    key: 'NUMERO_ETIQUETA',
    title: 'Número de etiqueta',
  },
  {
    key: 'INDICE_ITEM',
    title: 'Índice del item (1/X)',
  },
  {
    key: 'COMENTARIO_PEDIDO',
    title: 'Comentario del pedido',
  },
];

export const ItemLabelVariablesMap = new Map(
  ItemLabelVariables.map((v) => [v.key, v])
);
